import React from "react";
import "../../assets/css/FumoirGallery.css";
import fumoir1 from "../../assets/image/viande1.webp";
import fumoir2 from "../../assets/image/viande2.webp";
import fumoir3 from "../../assets/image/viande4.webp";
import fumoir4 from "../../assets/image/viande4.webp"; // Note: Vous importez deux fois viande4.webp
import fumoir5 from "../../assets/image/viande5.webp";
import fumoir6 from "../../assets/image/viande6.webp";
import fumoir7 from "../../assets/image/viande7.webp";
import fumoir8 from "../../assets/image/viande8.webp";
import fumoir9 from "../../assets/image/viande9.webp";
import fumoir10 from "../../assets/image/viande10.webp";
import fumoir11 from "../../assets/image/viande11.webp";
import { GiHotSurface } from "react-icons/gi";
import { useTranslation } from "react-i18next";

const images = [
    { id: 1, src: fumoir1, alt: "Fumoir Vue 1", cols: 2, rows: 2 }, // Plus grand
    { id: 2, src: fumoir2, alt: "Fumoir Vue 2", cols: 1, rows: 1 },
    { id: 3, src: fumoir3, alt: "Fumoir Vue 3", cols: 1, rows: 1 },
    { id: 4, src: fumoir5, alt: "Fumoir Vue 4", cols: 1, rows: 2 }, // Plus grand verticalement
    { id: 5, src: fumoir6, alt: "Fumoir Vue 5", cols: 2, rows: 1 }, // Plus large
    { id: 6, src: fumoir7, alt: "Fumoir Vue 6", cols: 1, rows: 1 },
    { id: 7, src: fumoir8, alt: "Fumoir Vue 7", cols: 1, rows: 1 },
    { id: 8, src: fumoir9, alt: "Fumoir Vue 8", cols: 2, rows: 1 }, // Plus large
    { id: 9, src: fumoir10, alt: "Fumoir Vue 9", cols: 1, rows: 1 },
    { id: 10, src: fumoir11, alt: "Fumoir Vue 10", cols: 1, rows: 2 }, // Plus grand verticalement
    // Vous pouvez ajouter d'autres images ici si vous en avez
];

function FumoirGallery() {
     const { t } = useTranslation("temoignage");
    return (
        <div className="fumoir-table-gallery">
            <GiHotSurface className="iconfumee" />
            <h2>{t("fume")}</h2>
            <div className="table-container">
                {images.map((image, index) => (
                    <div
                        key={image.id}
                        className={`table-cell cell-${index + 1}`}
                        style={{
                            gridColumn: `span ${image.cols || 1}`,
                            gridRow: `span ${image.rows || 1}`,
                        }}
                    >
                        <div className="image-wrapper">
                            <img src={image.src} alt={image.alt} />
                        </div>
                    </div>
                ))}
            </div>
    
        </div>
    );
}

export default FumoirGallery;
